import React, {useState} from 'react';

import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {showRightSidebarAction, toggleLeftmenu} from '../../store/actions';
import ProfileMenu from '../CommonForBoth/TopbarDropdown/ProfileMenu';
import logo from '../../assets/images/logo.svg';
import {withTranslation} from 'react-i18next';
import NotificationDropdown from
  '../CommonForBoth/TopbarDropdown/NotificationDropdown';
import SwitchDealerDropdown from
  '../CommonForBoth/TopbarDropdown/SwitchDealerDropdown';
import {Badge, Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import {getLoggedInUser} from '../../helpers/fakebackend_helper';
import {DEALER_FLAG_NON_TEXTILE, DEALER_FLAG_TEXTILE} from '../Dealer/DealerConst';

const Header = (props) => {
  const authUser = getLoggedInUser();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo">
                <span className="logo-sm">
                  <img src={logo} alt="" height="20"/>
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="30"/>
                </span>
              </Link>
            </div>

            <div className="align-self-center ml-2">
              <Badge
                color="white"
                className="font-size-18 text-uppercase font-weight-bold">
                {process.env.REACT_APP_REALM}
              </Badge>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item
              waves-effect waves-light"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content">
              <i className="fa fa-fw fa-bars"></i>
            </button>
          </div>

          <div className="d-flex">

            {['test', 'bimh', 'bbo'].includes(process.env.REACT_APP_REALM) ?
              <a href='https://brother.zohodesk.eu/portal/en/home' target='_blank' rel="noreferrer" className="d-none d-lg-block">
                <button
                  type="button"
                  className="btn btn-sm header-item waves-effect waves-light
                  d-flex align-items-center">
                  <svg style={{width: '20px'}} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3 20.3574C3 21.8896 4.06071 23.1431 5.35714 23.1431H21.8571L26.5714 28.7146V3.64314C26.5714 2.11099 25.5107 0.857422 24.2143 0.857422H5.35714C4.06071 0.857422 3 2.11099 3 3.64314V20.3574Z"
                      fill="white"/>
                    <rect x="12.8574" y="9.35742" width="3.42857" height="9.70779" rx="1.71429" fill="#1E1E1E"/>
                    <ellipse cx="14.5717" cy="6.40316" rx="1.71429" ry="1.68831" fill="#1E1E1E"/>
                  </svg>
                  <span className="font-size-13 ml-2">
                      Technical Support Center
                  </span>
                </button>
              </a> : ''
            }

            {['test', 'bimh', 'bbo'].includes(process.env.REACT_APP_REALM) &&
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle
                  className="btn header-item noti-icon waves-effect"
                  tag="button" id="page-header-notifications-dropdown"
                >
                  <i className="mdi mdi-cloud-download font-size-16"/>
                  <span className="font-size-13 ml-2">Downloads</span>
                </DropdownToggle>
                <DropdownMenu>
                  { authUser?.user.flags?.includes(DEALER_FLAG_NON_TEXTILE) && <DropdownItem><Link to={'/downloads/non-textile'} className="d-none d-lg-block">Downloads Non-Textile</Link></DropdownItem> }
                  { authUser?.user.flags?.includes(DEALER_FLAG_TEXTILE) && <DropdownItem><Link to={'/downloads/textile'} className="d-none d-lg-block">Downloads Textile</Link></DropdownItem> }
                </DropdownMenu>
              </Dropdown>
            }

            <SwitchDealerDropdown/>

            <NotificationDropdown/>

            <ProfileMenu/>

          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const {layoutType, showRightSidebar, leftMenu} = state.Layout;
  return {layoutType, showRightSidebar, leftMenu};
};

export default connect(
    mapStatetoProps, {showRightSidebarAction, toggleLeftmenu},
)(withTranslation()(Header));


